import { computed, defineComponent } from "vue";
import store from "@/store";

export default defineComponent({
  name: "AppAbout",
  setup() {
    const parentPage = computed(() => store.state.navigation.aboutParentPage);

    return {
      parentPage
    };
  }
});
